// extracted by mini-css-extract-plugin
export default {"wrapper":"SlotLabel_wrapper__-bnPx"};